CommandeDeclotureValidator.$inject = ['validator'];

export default function CommandeDeclotureValidator(validator) {
    const instance = new validator();

    return instance;
}